import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const RECENT_PURCHASES = [{
  name: 'Marina',
  city: 'Rosario',
  product: 'Megapack Danza Clásica Pro'
}, {
  name: 'Carla',
  city: 'Córdoba',
  product: 'Megapack Danza Clásica Pro'
}, {
  name: 'Vicky',
  city: 'Mendoza',
  product: 'Megapack Danza Clásica Pro'
}];
const VISIBLE_DURATION = 10000;
const HIDDEN_DURATION = 30000;
export function SocialProofToast() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return undefined;
    const timer = window.setTimeout(() => {
      if (isVisible) {
        setIsVisible(false);
        return;
      }
      setActiveIndex(current => (current + 1) % RECENT_PURCHASES.length);
      setIsVisible(true);
    }, isVisible ? VISIBLE_DURATION : HIDDEN_DURATION);
    return () => window.clearTimeout(timer);
  }, [isDismissed, isVisible]);
  if (isDismissed || !isVisible) return null;
  const purchase = RECENT_PURCHASES[activeIndex];
  return <aside key={`${purchase.name}-${purchase.city}`} className="social-proof-enter fixed bottom-3 left-3 right-3 z-50 flex max-w-sm items-start gap-3 rounded-2xl border border-lime/70 bg-ink p-3.5 shadow-[0_14px_34px_rgba(0,0,0,0.45)] sm:bottom-6 sm:left-6 sm:right-auto sm:p-4" aria-live="polite" aria-label="Compra reciente" data-id="element-303" data-mp="kedk7lcn7l4r">
      <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-lime/15 text-lime" data-id="element-304" data-mp="13a3ndbwbank8">
        <ShoppingBagIcon className="h-5 w-5" aria-hidden="true" data-id="element-305" data-mp="182wto47fi3yf" />
      </span>
      <div className="min-w-0 flex-1 pr-1" data-id="element-306" data-mp="1czwotk2qpmar">
        <p className="text-[10px] font-extrabold uppercase tracking-[0.16em] text-lime" data-id="element-307" data-mp="1d32dwzbdco6h">Compra reciente</p>
        <p className="mt-0.5 text-sm font-bold text-snow" data-id="element-308" data-mp="1m1w7shxbf0gc">
          {purchase.name} de {purchase.city}
        </p>
        <p className="mt-0.5 text-xs leading-snug text-snow-muted" data-id="element-309" data-mp="3j20pajej208b">
          Eligió {purchase.product} · acceso inmediato
        </p>
      </div>
      <button type="button" onClick={() => setIsDismissed(true)} className="-m-1.5 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full text-snow-dim transition-colors hover:text-snow focus:outline-none focus-visible:ring-2 focus-visible:ring-lime" aria-label="Cerrar notificación" data-id="element-310" data-mp="3e50gw1u7gle1">
        <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-311" data-mp="ojaj4ndsz4c" />
      </button>
    </aside>;
}